import { Col, Row } from 'react-bootstrap';

import { DateTimeInput, StringInput, CheckboxInput } from '../core/components/forms';
import { dateUtils } from '../core/utils';
import Can from '../permissions/abilities/Can';
import { RefValueSelector } from '../core/components/selectors';
import ClientFCMTokens from '../clients/ClientFCMTokens';

interface ClientPersonalInfoProps {
  clientId: string,
}

const ClientPersonalInfo = (props: ClientPersonalInfoProps ) => {
  const {
    clientId,
  } = props;

  return (
    <>
      <Col md={ 12 }>
        <Can do='permissionUpdate' on='reference.person.card.personal.data' passThrough>
          { can => (
            <Row>
              <Col md={ 12 }>
                <Row>
                  <Col md={ 4 }>
                    <StringInput
                      name='lastName'
                      placeholder='Фамилия'
                      label='Фамилия'
                      disabled={ !can }
                    />
                  </Col>
                  <Col md={ 4 }>
                    <StringInput
                      name='firstName'
                      placeholder='Имя'
                      label='Имя'
                      disabled={ !can }
                    />
                  </Col>
                  <Col md={ 4 }>
                    <StringInput
                      name='middleName'
                      placeholder='Отчество'
                      label='Отчество'
                      disabled={ !can }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={ 4 }>
                    <DateTimeInput
                      name='createdDate'
                      placeholder='Дата регистрации'
                      label='Дата регистрации'
                      disabled
                    />
                  </Col>
                  <Col md={ 4 }>
                    <StringInput
                      name='statusRefValueName'
                      placeholder='Статус в системе'
                      label='Статус в системе'
                      disabled
                    />
                  </Col>
                  <Col md={ 4 }>
                    <StringInput
                      label='Кто зарегистрировал'
                      name='createdByUserName'
                      disabled
                    />
                  </Col>
                  <Col md={ 3 }>
                    <DateTimeInput
                      name='dateOfBirth'
                      label='Дата рождения'
                      placeholder='Дата рождения'
                      displayFormat='dd.MM.yyyy'
                      serverFormat='yyyy-MM-dd'
                      showTime={ false }
                      minDate={ dateUtils.yearsAgo(100) }
                    />
                  </Col>
                  <Col md={ 3 }>
                    <RefValueSelector
                      name='genderRefValueId'
                      refId={ 52 }
                      label='Пол'
                      placeholder='Пол'
                    />
                  </Col>
                  <Col md={ 3 }>
                    <StringInput
                      name='partnerName'
                      label='Партнёр'
                      disabled={ true }
                    />
                  </Col>
                  <Col md={ 3 }>
                    <StringInput
                      name='bonus'
                      label='Бонусы'
                      disabled={ true }
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={ 4 }>
                    <CheckboxInput
                      label='Не отправлять сообщение в телеграмм'
                      name='suppressMessageToTelegramChat'
                    />
                  </Col>
                  <Col md={ 4 }>
                    <CheckboxInput
                      label='Не отправлять СМС'
                      name='suppressSms'
                    />
                  </Col>
                  <Col md={ 4 }>
                    <CheckboxInput
                      label='Тестировщик'
                      name='testClientMarkedAtBool'
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          ) }
        </Can>
      </Col>
      <Col md={ 12 }>
        <ClientFCMTokens clientId={ clientId } />      
      </Col>
    </>
  );
};

export default ClientPersonalInfo;
